/** Activity tab for the Customer Workspace (Demo Mode only). Shows the audit trail, notes,
 * recent changes, decisions and onboarding history for the customer - see
 * `../../../../mocks/data/customerManagementData.ts`. */

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Section } from '../../../../components/ui/Section';
import { TableHeader } from '../../../../components/forms/TableHeader';
import { Pill } from '../../../../components/shared/Pill';
import { CustomerRecord } from '../../../../mocks/data/customerManagementData';

interface ActivityTabProps {
  customer: CustomerRecord;
}

const ActivityTab = ({ customer }: ActivityTabProps) => {
  const { t } = useTranslation('common');

  return (
    <Section>
      <TableHeader>
        {t('activityTableTitle', 'Activity history')}
        <Pill text={`${customer.activity.length} ${t('activityCountLabel', 'entries')}`} />
      </TableHeader>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('activityDate', 'Date')}</TableCell>
              <TableCell>{t('activityActor', 'Actor')}</TableCell>
              <TableCell>{t('activityAction', 'Action')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {customer.activity.map((entry) => (
              <TableRow key={`${entry.date}-${entry.action}`}>
                <TableCell>{entry.date}</TableCell>
                <TableCell>{entry.actor}</TableCell>
                <TableCell>{entry.action}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Section>
  );
};

export default ActivityTab;
